import jQuery from 'jquery';

export default function () {
	const elements = queue();
	queue = function (fn) {
		fn.call(fn, jQuery);
	};
	for(let i = 0; i < elements.length; i++) {
		queue(elements[i]);
	}
}
